
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLocationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 30,
  width: 24,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "5.33 2 21.33 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 8.333a4.334 4.334 0 1 1 0 8.668 4.334 4.334 0 0 1 0-8.668Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 3c2.548 0 5.002 1.062 6.819 2.97 1.818 1.91 2.847 4.51 2.847 7.23 0 3.427-2.146 7.222-4.518 10.323a43.513 43.513 0 0 1-3.27 3.782c-.46.474-.853.856-1.142 1.13-.145.136-.264.245-.351.323-.092.082-.132.116-.134.117l-.027.021-.026.024A.297.297 0 0 1 16 29a.297.297 0 0 1-.196-.078c-.201-.183-2.6-2.365-4.94-5.417-2.378-3.1-4.53-6.886-4.53-10.305 0-2.72 1.03-5.32 2.848-7.23C10.999 4.062 13.452 3 16 3Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2
})));

      const __svgRaw = "<svg height=\"30\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"5.33 2 21.33 28\">   <path d=\"M15.9998 8.33331C18.3929 8.33331 20.3336 10.2732 20.3337 12.6663C20.3337 15.0596 18.393 17.0003 15.9998 17.0003C13.6067 17.0001 11.6667 15.0594 11.6667 12.6663C11.6669 10.2733 13.6068 8.33349 15.9998 8.33331Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\"></path>   <path d=\"M16.0002 3C18.5477 3.00009 21.0016 4.06193 22.8186 5.96973C24.6372 7.87927 25.6663 10.4797 25.6663 13.2002C25.6662 16.6268 23.5199 20.4224 21.1477 23.5225C19.9811 25.047 18.7978 26.3554 17.8772 27.3047C17.4176 27.7786 17.025 28.1613 16.7356 28.4346C16.5908 28.5713 16.4719 28.6798 16.385 28.7578C16.2934 28.84 16.2528 28.8736 16.2512 28.875L16.2239 28.8965L16.1985 28.9199C16.1363 28.9758 16.0655 28.9999 16.0002 29C15.9357 29 15.8657 28.9763 15.804 28.9219C15.603 28.739 13.2047 26.5571 10.8635 23.5049C8.48643 20.4057 6.33335 16.6185 6.33325 13.2002C6.33325 10.4797 7.36327 7.87927 9.18188 5.96973C10.9989 4.06205 13.4528 3 16.0002 3Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\"></path> \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/location-icon.30aee2c02919617fe42eca258db2f594.svg"),
        {
          React: SvgLocationIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      